import React, { useCallback, useEffect, useState } from "react";
import styled from "styled-components";
import { SearchOutlined } from "@mui/icons-material";
import { Button, Col, Form, Input, message, Modal, Row, Spin } from "antd";
import COLORS from "common/Colors";
import { DropdownCheckBox } from "atoms/UIDropdown/Dropdown";
import { Table } from "antd";
import { ReactComponent as Editicon } from "../../assets/Edit_Pencil_01.svg";
import { ReactComponent as TrashDelete } from "../../assets/Trash_Full.svg";
import { ButtonFilled } from "reusableComponent/UIButtons";
import DescriptionModal from "./ModalView";
import HistoryModal from "./HistoryModalView";
import { CALL_API } from "common/API";
import { connect } from "react-redux";
import { getUserInfo, getUserList, getGradeList, getMenuList, getUserRoleId } from "redux/selectors";
import { ReactComponent as CircleWarning } from "../../assets/icons/Circle_Warning.svg";

const StyledButton = styled(Button)`
  width: 150px;
  color: white;
  background-color: #b7b7b7;
  border-radius: 5px;
  margin-left: 5%;
`;

const Styleddiv = styled.div`
  .title_button {
    display: flex;
    justify-content: space-between;
  }
  .job_title {
    font-size: 18px;
    font-weight: 500;
  }
  .add_button_jd {
    border-radius: 8px;
    width: 170px;
    height: 34px;
  }
  .jd_count {
    font-size: 16px;
    font-weight: 400;
  }
  .search_input {
    width: 176px;
    height: 34px;
  }
  .search_dropdown {
    display: flex;
    gap: 20px;
  }
  .dropdown_style {
    width: 176px;
    height: 34px;
  }
  .add_button {
    width: 130px;
    height: 34px;
    border-radius: 8px;
  }
`;

const StyledTable = styled(Table)`
  padding-top: 10px;
  table {
    width: 100% !important;
    border: 1px solid #ccc;
    /* border-radius: 10px; */
  }
  .ant-table-content {
    overflow-x: auto;
    white-space: nowrap;
    /* border-radius: 10px; */
    color: ${COLORS.TEXT.PRIMARY};
    font-size: 14px;
  }
  .ant-table-row:nth-child(even) {
    background-color: #fafafa;
  }
  .normal-column {
    min-width: 300px;
    white-space: normal;
  }
  .ant-table-thead .ant-table-cell {
    font-weight: bold;
    color: ${COLORS.TEXT.PRIMARY};
    white-space: nowrap;
  }
  .non-white {
    background: #f9f9f9;
  }
  .ant-select-selector {
    min-width: 150px;
  }
`;

const StyledModal = styled(Modal)`
  .ant-modal-header {
    border-bottom: none;
    padding-top: 20px;
  }

  .ant-modal-footer {
    border-top: none;
    padding-bottom: 20px;
  }

  .ant-modal-close-x {
    display: none;
  }
`;

const JobDescription = ({ userInfo, userList, gradeList, menuList, userRoleId }) => {
  // Permissions of Settings -> Job Description for the logged-in user's role
  const Menulist = menuList?.[userRoleId] || Object.values(menuList || {})[0];
  const hasJdPermission = (type) =>
    !!Menulist?.find(
      (item) =>
        item?.key === "manage" &&
        item?.subMenu?.find(
          (subItem) =>
            subItem?.key === "jobdescription" && subItem?.permission?.[type]
        )
    );
  const canCreateJd = hasJdPermission("create");
  const canEditJd = hasJdPermission("edit");
  const canDeleteJd = hasJdPermission("delete");
  const Grade = (gradeList || []).map((item) => item.jobgradecode);
  const styledIcon = { color: `${COLORS.TEXT.PRIMARY}`, fontSize: "18px" };
  const [form] = Form.useForm();
  const [hoveredRow, setHoveredRow] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [isHistoryModalOpen, setIsHistoryModalOpen] = useState(false);
  const [isHistoryModalLoader, setIsHistoryModalLoader] = useState(false);
  const [data, setData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [rowSpanMap, setRowSpanMap] = useState({});
  const [searchItem, setSearchItem] = useState("");
  const [selectedRecord, setSelectedRecord] = useState(null);
  const [historyData, setHistoryData] = useState([]);
  const [loader, setLoader] = useState(false);

  const headerstyle = { fontSize: "20px", fontWeight: "bold" };

  useEffect(() => {
    getJobDescription();
  }, []);

  const computeRowSpanMap = (data, field) => {
    const spanMap = {};
    let lastValue = null;
    let count = 0;
    let startIndex = 0;

    data?.forEach((item, index) => {
      if (item[field] !== lastValue) {
        if (count > 0) spanMap[startIndex] = count;
        lastValue = item[field];
        startIndex = index;
        count = 1;
      } else {
        count++;
      }
    });

    if (count > 0) spanMap[startIndex] = count;
    return spanMap;
  };

  const keyRowSpanMap = computeRowSpanMap(filteredData, "jobGradeCode");
  const jobGradeRowSpanMap = keyRowSpanMap;

  const getJobDescription = async () => {
    try {
      setLoader(true);
      const response = await CALL_API(`appraisal/jobdescription`, "GET");
      if (response?.code === "SUCCESS") {
        const filteredData = response?.data?.filter(
          (item) => item.additionalFile === "No" && item.jobGradeCode !== "CUSTOM"
        );
        setData(filteredData);
        setLoader(false);
      }
    } catch (error) {
      console.error("[getJobDescription] error -->", error);
    }
  };

  const applySearchAndFilter = useCallback(() => {
    const lowerSearch = searchItem.toLowerCase();
    const selectedGrades = form.getFieldValue("grade") || [];

    let result = data?.filter((item) => {
      const matchesSearch = Object.values(item).some((val) =>
        val?.toString().toLowerCase().includes(lowerSearch)
      );
      const matchesGrade =
        selectedGrades.length === 0 ||
        selectedGrades.includes(item?.jobGradeCode);
      return matchesSearch && matchesGrade;
    });

    // Sort according to the Grade array order
    result = result.sort((a, b) => {
      const indexA = Grade.indexOf(a.jobGradeCode);
      const indexB = Grade.indexOf(b.jobGradeCode);
      return (
        (indexA === -1 ? Infinity : indexA) -
        (indexB === -1 ? Infinity : indexB)
      );
    });

    const newMap = computeRowSpanMap(result, "jobGradeCode");
    setFilteredData(result);
    setRowSpanMap(newMap);
  }, [data, searchItem, form]);

  useEffect(() => {
    applySearchAndFilter();
  }, [applySearchAndFilter]);

  const showModal = () => {
    setIsModalOpen(true);
  };

  const showHistoryModal = async (record) => {
    setIsHistoryModalOpen(true);
    setIsHistoryModalLoader(true);
    try {
      const response = await CALL_API(
        `appraisal/jobdescriptionhistory?jobgradecode=${record?.jobGradeCode}&jobdescriptionid=${record?.jobDescriptionId}`,
        "get"
      );
      if (response?.code === "SUCCESS") {
        setHistoryData(response?.historyList);
      } else {
        console.error("History fetch failed", response);
      }
    } catch (error) {
      console.error("Error fetching history", error);
    } finally {
      setIsHistoryModalLoader(false);
    }
  };

  const handleDelete = (record) => {
    if (!canDeleteJd) return;
    if (!Array.isArray(userList)) {
      message.error("Invalid user data.");
      return;
    }
    const userAppraisalInfo = userList.filter(
      (item) => item?.userid === userInfo?.userid
    )?.[0]?.appraisalInformation?.[0];

    const jobdescriptionFileId = userAppraisalInfo?.jobdescriptionFileId;
    const usersWithSameGrade = userList.filter(
      (user) => user?.grade === record?.jobGradeCode
    );
    usersWithSameGrade.forEach((user, index) => {
      const userJDId = user?.appraisalInformation?.[0]?.jobDescriptionId;
    });
    const isUsedByEmployee = usersWithSameGrade.some((user, index) => {
      const userJDId = user?.appraisalInformation?.[0]?.jobDescriptionId;
      const jdMatch = userJDId === record?.jobDescriptionId;
      return jdMatch;
    });
    setSelectedRecord(record);
    if (isUsedByEmployee) {
      setIsDeleteModalOpen(true);
    } else {
      Modal.confirm({
        icon: null,
        content: (
          <p style={{ fontWeight: 400, fontSize: "16px", marginBottom: 0 }}>
            Are you sure you want to delete this job description?
          </p>
        ),
        centered: true,
        okText: "Yes",
        cancelText: "No",
        okButtonProps: {
          style: {
            width: 130,
            height: 34,
            borderRadius: 8,
            borderWidth: 1,
          },
        },
        cancelButtonProps: {
          style: {
            width: 130,
            height: 34,
            borderRadius: 8,
            borderWidth: 1,
          },
        },
        async onOk() {
          try {
            const response = await CALL_API(
              `appraisal/deletejobdescription?jobgradecode=${record?.jobGradeCode}&jobdescriptionid=${record?.jobDescriptionId}`,
              "delete"
            );
            if (response?.code === "SUCCESS") {
              message.success("Job Description deleted successfully");
              getJobDescription();
            } else {
              message.error("Failed to delete Job Description");
            }
          } catch (error) {
            console.error("[Delete Error]", error);
            message.error("Error deleting Job Description");
          }
        },
      });
    }
  };

  const handleOk = () => {
    setIsDeleteModalOpen(false);
  };

  const handleEditJobDeccription = (record) => {
    if (!canEditJd) return;
    setIsEdit(true);
    showModal();
    setSelectedRecord(record);
  };

  const columns = [
    {
      title: "Job Grade Code",
      dataIndex: "jobGradeCode",
      width: 150,
      onCell: (_, index) => ({
        rowSpan: jobGradeRowSpanMap[index] ?? 0,
      }),
    },
    {
      title: "Job Grade",
      dataIndex: "jobGrade",
      onCell: (_, index) => ({
        rowSpan: jobGradeRowSpanMap[index] ?? 0,
      }),
    },
    {
      title: "File Name",
      dataIndex: "fileName",
    },
    {
      title: "File ID",
      dataIndex: "fileId",
    },
    {
      title: "From Date",
      dataIndex: "fromDate",
    },
    {
      title: "To Date",
      dataIndex: "toDate",
    },
    {
      title: "Action",
      dataIndex: "action",
      width: 300,
      align: "center",
      render: (_, record, index) => {
        const isVisible = hoveredRow === index;
        return (
          <div className={`action-icons ${isVisible ? "visible" : ""}`}>
            {canEditJd && (
              <Editicon
                onClick={() => {
                  handleEditJobDeccription(record);
                }}
                style={{ cursor: "pointer", backgroundColor: "#C2FAE5" }}
              />
            )}
            {canDeleteJd && (
              <TrashDelete
                onClick={() => handleDelete(record)}
                style={{
                  cursor: "pointer",
                  marginLeft: 8,
                  backgroundColor: "#C2FAE5",
                }}
              />
            )}
            <ButtonFilled
              style={{ marginLeft: 8 }}
              onClick={() => showHistoryModal(record)}
            >
              History
            </ButtonFilled>
          </div>
        );
      },
    },
  ];

  const gradeOptions = Grade?.map((item) => ({
    label: item,
    value: item,
  }));

  const employers = userList?.find((user) => user?.userid === userInfo?.userid);
  return (
    <Styleddiv>
      <Row className="page-title">
        <Col sm={24} md={12} style={headerstyle}>
          List of Job Description
        </Col>
        <Col sm={24} md={12} className="align-right">
          {canCreateJd && (
            <StyledButton
              className="mx-0"
              type="primary"
              htmlType="submit"
              onClick={showModal}
            >
              Add New JD
            </StyledButton>
          )}
        </Col>
      </Row>
      <br />
      <div className="title_button">
        <div>
          <p className="jd_count">List of JD: {filteredData?.length}</p>
        </div>
        <Form
          form={form}
          layout="vertical"
          onValuesChange={applySearchAndFilter}
        >
          <div className="search_dropdown">
            <div className="search_input">
              <Input
                prefix={<SearchOutlined style={styledIcon} />}
                placeholder="Search"
                style={{ borderRadius: "24px" }}
                value={searchItem}
                onChange={(e) => setSearchItem(e.target.value)}
              />
            </div>
            <div className="dropdown_style">
              <DropdownCheckBox
                name="grade"
                label="Grade"
                options={gradeOptions}
                form={form}
                handleFormChange={() => {
                  applySearchAndFilter();
                }}
              />
            </div>
          </div>
        </Form>
      </div>
      <br />
      <Spin spinning={loader}>
        <StyledTable
          columns={columns}
          dataSource={filteredData}
          rowKey={(r, i) => i}
          pagination={false}
        />
      </Spin>
      <StyledModal
        title=""
        centered
        open={isDeleteModalOpen}
        footer={[
          <Button
            key="add"
            type="primary"
            onClick={handleOk}
            style={{ width: "130px", height: "34px", borderRadius: "8px" }}
          >
            Got it
          </Button>,
        ]}
        bodyStyle={{ padding: "20px 14px" }}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            marginTop: "1em",
          }}
        >
          <CircleWarning
            style={{ width: 48, height: 48, marginBottom: "0.8em" }}
          />
          <p
            style={{
              fontWeight: "400",
              fontSize: "16px",
              textAlign: "center",
              marginBottom: 0,
            }}
          >
            You cannot delete this Job Description as it has <br />
            been used for some employees
          </p>
        </div>
      </StyledModal>

      <DescriptionModal
        isModalOpen={isModalOpen}
        setIsModalOpen={setIsModalOpen}
        isEdit={isEdit}
        setIsEdit={setIsEdit}
        onSuccess={getJobDescription}
        selectedRecord={selectedRecord}
        employers={employers}
      />
      <HistoryModal
        isHistoryModalOpen={isHistoryModalOpen}
        setIsHistoryModalOpen={setIsHistoryModalOpen}
        historyData={historyData}
        isHistoryModalLoader={isHistoryModalLoader}
      />
    </Styleddiv>
  );
};

const mapStateToProps = (state) => ({
  userInfo: getUserInfo(state),
  userList: getUserList(state),
  gradeList: getGradeList(state),
  menuList: getMenuList(state),
  userRoleId: getUserRoleId(state),
});

export default connect(mapStateToProps, null)(JobDescription);
